import { SKIP_FORBIDDEN } from './httpConfig';

export class ChannelApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getChannels() {
    // The channel catalog (Pricing) is not broker-authorized; a TPO sub-company user gets a 403 here,
    // which must NOT trigger the global forbidden page-reload. The Company Manager Approvals tab degrades
    // to its "contact your AE" channels state when the catalog is absent.
    return this.#http.get('/api/channels', {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }

  async editChannel({ channelId, ...body }) {
    return this.#http.put(`/api/channels/${channelId}`, body);
  }

  async createChannel(body) {
    return this.#http.post('/api/channels', body);
  }

  async deleteChannel({ channelId }) {
    return this.#http.delete(`/api/channels/${channelId}`);
  }

  // LEN-804: the channel a loan with no channel (retail and legacy loans) prices on; { channelId } with
  // null for none. Read needs Channel view, save Channel edit — a 403 reaches the card, not the global
  // page reload.
  async getDefaultPricingChannel() {
    return this.#http.get('/api/channels/default-pricing-channel', SKIP_FORBIDDEN);
  }

  async updateDefaultPricingChannel(channelId) {
    return this.#http.put('/api/channels/default-pricing-channel', { channelId }, SKIP_FORBIDDEN);
  }
}
